module.exports = __webpack_public_path__ + "img/worgen-m-70.ed733c8b.gif";